<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Suppliers",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Full Name",
          sortable: true,
        },
        {
          key: "phone",
          label: "Phone Number",
          sortable: true,
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
        },
        {
          key: "email",
          label: "Email Address",
          sortable: true,
        },
        {
          key: "date",
          label: "Added On",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        email: "",
        address: "",
        phone: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        phone: "",
        email: "",
        address: "",
        id: "",
      },
      existing: [],
      nameError: "",
      addressError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("expenses", ["Suppliers", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Suppliers ? this.Suppliers.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Suppliers ? this.Suppliers.length : 1;
  },
  methods: {
    ...mapActions({
      FetchSuppliers: "expenses/fetchSuppliers",
      AddSupplier: "expenses/addSupplier",
      EditSupplier: "expenses/editSupplier",
      DeleteSupplier: "expenses/deleteSupplier",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.Suppliers ? this.Suppliers.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
      this.addressError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.email = "";
      this.data.phone = "";
      this.data.address = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.phone = "";
      this.editdata.email = "";
      this.editdata.address = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    checkName() {
      if (this.data.name != "" && this.data.address != "") {
        this.existing = this.Suppliers.filter((supplier) => {
          return (
            supplier.name.toUpperCase() == this.data.name.toUpperCase() &&
            supplier.address.toUpperCase() == this.data.address.toUpperCase()
          );
        });
        if (this.existing.length) {
          this.nameError =
            "Supplier with name " +
            this.data.name +
            " and address " +
            this.data.address +
            " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existing = [];
      }
    },
    addSupplier(modal) {
      if (this.data.name == "") {
        this.nameError = "Supplier Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.address == "") {
        this.addressError = "Suppler Address is required";
        return;
      } else {
        this.addressError = "";
      }
      if (this.existing.length) {
        this.nameError =
          "Supplier with name " + this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddSupplier(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.phone = values.item.phone;
      this.editdata.address = values.item.address;
      this.editdata.email = values.item.email;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteSupplier(modal) {
      this.modal = modal;
      this.DeleteSupplier(this.deletedata);
      this.closeModal(modal);
    },
    editSupplier(modal) {
      if (this.editdata.name == "") {
        this.nameError = "Supplier Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.address == "") {
        this.addressError = "Supplier Address field can't be empty";
        return;
      } else {
        this.addressError = "";
      }
      this.modal = modal;
      this.EditSupplier(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSuppliers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_supplier')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of All Suppliers</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_suppliers')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Suppliers ? Suppliers : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      v-b-modal.edit-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_supplier')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      v-b-modal.delete-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_supplier')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_suppliers')
          )
        "
      >
        <template #modal-title> Add New Supplier </template>
        <div class="form-group mb-3">
          <label>Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Supplier Name"
              class="form-control"
              @input="resetError()"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Address</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Supplier Location"
              class="form-control"
              @input="resetError()"
              v-model="data.address"
            />
          </div>
          <div class="text-danger" v-if="addressError">
            <em>{{ addressError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number</label>
          <div class="input-group">
            <input
              type="number"
              placeholder="Supplier Phone Number"
              class="form-control"
              @input="resetError()"
              v-model="data.phone"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Email Address</label>
          <div class="input-group">
            <input
              type="email"
              placeholder="Supplier Email Address"
              class="form-control"
              @input="resetError()"
              v-model="data.email"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addSupplier('add-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_supplier')
          )
        "
      >
        <template #modal-title> Edit Supplier {{ editdata.name }}</template>
        <div class="form-group mb-3">
          <label>Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError()"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Address</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Supplier Location"
              class="form-control"
              @input="resetError()"
              v-model="editdata.address"
            />
          </div>
          <div class="text-danger" v-if="addressError">
            <em>{{ addressError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number</label>
          <div class="input-group">
            <input
              type="number"
              placeholder="Supplier Phone Number"
              class="form-control"
              @input="resetError()"
              v-model="editdata.phone"
            />
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Email Address</label>
          <div class="input-group">
            <input
              type="email"
              placeholder="Supplier Email Address"
              class="form-control"
              @input="resetError()"
              v-model="editdata.email"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editSupplier('edit-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete fyear starts -->
      <b-modal
        id="delete-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_supplier')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Supplier {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Supplier {{ deletedata.name }}? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteSupplier('delete-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
